import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
	selector: 'app-delivery-status-dialog',
	templateUrl: './delivery-status-dialog.html',
	styleUrl: './delivery-status-dialog.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliveryStatusDialogComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: {providerText: string},
		public dialogRef: MatDialogRef<DeliveryStatusDialogComponent>
	) {}

	close() {
		this.dialogRef.close();
	}
}
